import { Injectable } from '@angular/core';
import { ClassUser } from '@models/user';
import { ClassSettingsRequest, IResponse } from '@models/response-and-request';
import { BehaviorSubject, finalize, from, Observable, of, switchMap, tap } from 'rxjs';
import { CdkDropList } from '@angular/cdk/drag-drop';
import {
  ClassGame,
  ClassGameOfficial,
  IForApiMethod_updateOfficials,
  IOfficialsAssign,
  TStatusAssignForSendToServer,
} from '@app/dir_group_assignor/games/game';
import { PopupService } from '@services/popup.service';
import { UnsavedChangesService } from '@services/unsaved-changes.service';
import { MainService } from '@services/main.service';
import {
  PopupSetStatusForAssignComponent,
} from '@app/dir_group_assignor/assign/components/popup-set-status-for-assign/popup-set-status-for-assign.component';
import { PopupComponent } from '@components/__popup-windows/popup/popup.component';
import { GameService } from '@app/dir_group_assignor/games/game.service';
import { UtilsService } from '@services/utils.service';
import { IGoToAssign } from '@app/dir_group_assignor/assign/models/assign';
import { Router } from '@angular/router';
import { urlAssign } from '@app/app.module';
import {
  TypeBlockGamesForDashboard,
} from '@app/dir_group_assignor/dashboard/components/dashboard-group-assignor/models/group-assignor.models';
import { DeviceService } from '@services/device.service';

@Injectable({ providedIn: 'root' })
export class AssignService {
  btnInspectIsActive = false;

  get isShowBtnInspect(): boolean {
    if (this.deviceS.isDesktop) {
      return true;
    } else {
      return this.selectedArrGo_assigned_and_savedInServer.length === 1;
    }
  }

  readonly amountForShowAllGO = 4; 
  haveDragDrop = false; 

  showTableOfficialsForMobile = false;

  constructor(
    private deviceS: DeviceService,
    private mainS: MainService,
    private popupS: PopupService,
    private unsavedChangesS: UnsavedChangesService,
    private gameS: GameService,
    private router: Router,
  ) {
  }

  resetAllForFirstOpenPage(): void {
    this.haveDragDrop = false;
    this.showTableOfficialsForMobile = false;
    this.settingsOfficials = new ClassSettingsRequest({ page: 1, size: 30 });
    this.isFirstLoadOfficials = true;
  }

  dataTable$ = new BehaviorSubject<IResponse<ClassGame>>({}); // for-table===
  arrContent$ = new BehaviorSubject<Array<ClassGame>>([]); // for-table===


  get selectedGame(): ClassGame | undefined {
    return this.arrContent$.getValue()?.find(el => el.isSelect);
  }

   updateGame(game: ClassGame | undefined, isNextPage: boolean): void {
    const current_idSelectedGame = this.selectedGame?.id;
    const currentValue_isShowAllOfficials = this.isShowAllOfficials;

    const unSelected_arrContent = this.unSelectAllGameAndAllGo();
    const updated_arrContent = UtilsService.replaceElemArrayById(unSelected_arrContent, { ...game, isSelect: !!game }); // !!! если game то надо выбрать её. если не передал, то значит не надо делать выбраной игру
    this.arrContent$.next(updated_arrContent);

    const changeType_listOfficials: boolean = currentValue_isShowAllOfficials !== this.isShowAllOfficials;

    const changeSelectedGame: boolean = !!current_idSelectedGame && this.selectedGame?.id !== current_idSelectedGame;

    if (!changeSelectedGame && !changeType_listOfficials) {
  return;
} else {
  this.settingsOfficials.page = 1;
  this.settingsOfficials.sort = 'distance';
}


    this.getListOfficials(isNextPage).toPromise().then((res) => {
    });
  }

  

  private unSelectAllGameAndAllGo(): Array<ClassGame> {
    const arrContent: Array<ClassGame> = this.arrContent$.getValue()?.map((el: ClassGame) => {
      const updated_gameOfficials = el.gameOfficials?.map(go => ({ ...go, isSelect: false }));
      return { ...el, gameOfficials: updated_gameOfficials, isSelect: false };
    });
    return arrContent;
  }
  


  get selectedArrGo(): Array<ClassGameOfficial> {
    return this.selectedGame?.gameOfficials?.filter(el => el.isSelect) || [];
  }


  get selectedArrGo_assigned_and_savedInServer(): Array<ClassGameOfficial> {
    return this.selectedArrGo.filter(go => UtilsService.isSaveInServer_officialAssign(go)); 
  }


  get selectedArrGo_assigned_and_not_savedInServer(): Array<ClassGameOfficial> {
    return this.selectedArrGo.filter(go => !!go.official && !UtilsService.isSaveInServer_officialAssign(go));
  }


  selectGO(game: ClassGame, go: ClassGameOfficial, isNextPage: boolean): void {
    if (game.gameStatus === 'CLOSED') return;
    this.btnInspectIsActive = false; 
    const updated_gameOfficials: Array<ClassGameOfficial> = game.gameOfficials || [];

    const isHave_selectedArrGo_in_updated_gameOfficials: boolean = !!updated_gameOfficials.find(el => el.isSelect);
    const updated_game: ClassGame | undefined = isHave_selectedArrGo_in_updated_gameOfficials
      ? { ...game, gameOfficials: updated_gameOfficials }
      : undefined;
    this.updateGame(updated_game, isNextPage);
  }


  // === OFFICIALS ===============================================================
  cdkDropListRef?: CdkDropList<any>;
  settingsOfficials = new ClassSettingsRequest({ page: 1, size: 30 });
  dataAllOfficials: IResponse<ClassUser> | null = null;
  allOfficials: Array<ClassUser> | null = null; 
  dataOfficialsByGameId: IResponse<ClassUser> | null = null;
  officialsByGameId: Array<ClassUser> | null = null;
  isFirstLoadOfficials = true; 
  loadingOfficialsSub$ = new BehaviorSubject<boolean>(false);


  get isShowAllOfficials(): boolean {
    if (this.isFirstLoadOfficials) return true; 
    if (this.btnInspectIsActive) return false;
    return !!this.selectedArrGo_assigned_and_savedInServer?.length || !this.selectedArrGo?.length;
  }

  get dataOfficials(): IResponse<ClassUser> | null {
    return this.isShowAllOfficials ? this.dataAllOfficials : this.dataOfficialsByGameId;
  }

  get officials(): Array<ClassUser> {
    return (this.isShowAllOfficials ? this.allOfficials : this.officialsByGameId) || [];
  }

  get loadingOfficials(): boolean {
    return this.loadingOfficialsSub$.getValue();
  }

  getListOfficials(isNextPage: boolean): Observable<IResponse<ClassUser> | null> {
    this.loadingOfficialsSub$.next(true);

    if (isNextPage)
      this.settingsOfficials.page = (this.settingsOfficials.page ?? 0) + 1;
    else
      this.settingsOfficials.page = 0;

    if (this.isShowAllOfficials) {
      delete this.settingsOfficials.gameId;
        if (this.settingsOfficials.sort === 'distance') {
        delete this.settingsOfficials.sort;
        }
     //  delete this.settingsOfficials.sort;
    } else {
      this.settingsOfficials.gameId = this.selectedGame?.id;
        if (!this.settingsOfficials.sort) {
         this.settingsOfficials.sort = 'distance';
      }
      const selectedGameId = this.selectedGame?.id;

      if (!selectedGameId) {
        // ✅ No selected game — remove gameId & sort
        delete this.settingsOfficials.gameId;

        if (this.settingsOfficials.sort === 'distance') {
          delete this.settingsOfficials.sort;
        }
      } else {
        // ✅ Game is selected — set gameId, and assign sort = distance if not already set
        this.settingsOfficials.gameId = selectedGameId;

        if (!this.settingsOfficials.sort) {
          this.settingsOfficials.sort = 'distance';
        }
      }


      // if (!this.selectedGame?.id) console.error('getListOfficials selectedGame 222:', this.selectedGame?.id, this.selectedGame);
    }

    return this.mainS.getListOfficials({ params: this.settingsOfficials }, 'ACTIVE', false)
      .pipe(
        tap((res: IResponse<ClassUser>) => {
          if (this.isShowAllOfficials) {
            this.dataAllOfficials = res;
            this.allOfficials = isNextPage ? [...this.allOfficials || [], ...res?.content || []] : res?.content || [];
          } else {
            this.dataOfficialsByGameId = res;
            this.officialsByGameId = isNextPage ? [...this.officialsByGameId || [], ...res?.content || []] : res?.content || [];
          }
          this.isFirstLoadOfficials = false;
        }),
        finalize(() => {
          this.loadingOfficialsSub$.next(false);
        }),
      );
  }

  assignOfficials(isPublish: boolean): Observable<null> {
    const arrGoIdsForDeleteFromServer: Array<string> = [];

    const sendObj: IOfficialsAssign = { publish: isPublish, officialsAssign: [] };
    this.arrContent$.getValue()?.map((game) => {
      game?.gameOfficials?.forEach((go: ClassGameOfficial, idx) => {
        if (go?.official?.id) sendObj.officialsAssign?.push({ officialId: go?.official?.id, gameOfficialId: go?.id });
        if (go?.officialId_savedInServer && go?.officialId_savedInServer !== go.official?.id) { 
          arrGoIdsForDeleteFromServer.push(go.id!);
        }
      });
    });

    const observable$ = arrGoIdsForDeleteFromServer.length
      ? this.mainS.removeOfficials(arrGoIdsForDeleteFromServer).pipe(switchMap((res) => this.mainS.assignOfficials(sendObj)))
      : this.mainS.assignOfficials(sendObj);

    return observable$.pipe(
      tap((res) => {
        this.unsavedChangesS.unsavedChanges = false;
        this.mainS.deleteApiCache(this.mainS.apiOfficials);
        this.haveDragDrop = false; 
      }),
    );
  };


  openPopupSetStatus(): Observable<Array<IForApiMethod_updateOfficials> | null> {
    const arrSelectedGO_savedInServer = this.selectedArrGo.filter(el => !!el.officialId_savedInServer); 
    if (arrSelectedGO_savedInServer?.length) { 
      console.log('SEND TO SERVER :', arrSelectedGO_savedInServer);
      return from(this.popupS.open(PopupSetStatusForAssignComponent, { width: '400px' }))
        .pipe(
          switchMap((resPopup?: TStatusAssignForSendToServer) => {
            if (resPopup) {
              return this.mainS.updateOfficials(arrSelectedGO_savedInServer.map(el => ({ id: el.id, status: resPopup })))
                .pipe(
                  tap((res) => { 
                    const updated_gameOfficials = this.selectedGame?.gameOfficials?.map((currentGo) => {
                      const goFromServer = res?.find(elemResponse => elemResponse.id === currentGo.id); 
                      if (goFromServer) {
                        const updated_findGo: ClassGameOfficial = { ...currentGo, ...goFromServer };
                        return updated_findGo;
                      } else {
                        return currentGo;
                      }
                    }) || [];
                    const updated_game: ClassGame = { ...this.selectedGame, gameOfficials: updated_gameOfficials };
                    this.updateGame(updated_game, false);
                  }),
                );
            } else {
              return of(null);
            }
          }),
        );
    } else {
      return of(null);
    }
  };

  openPopupRemoveOfficials(): Observable<Array<string> | null> {
    const arrSelectedGO_savedInServer = this.selectedArrGo.filter(el => !!el.officialId_savedInServer); 
    if (arrSelectedGO_savedInServer?.length) {
      this.gameS.dataPopupForRemoveOfficialFromGO.swapBtn = this.deviceS.isDesktop;
      return from(this.popupS.open(PopupComponent, this.gameS.dataPopupForRemoveOfficialFromGO))
        .pipe(
          switchMap((resPopup?: boolean) => {
            if (resPopup) {
              return this.mainS.removeOfficials(arrSelectedGO_savedInServer.map(el => el.id!))
                .pipe(
                  tap((res) => { 
                    this.mainS.deleteApiCache(this.mainS.apiOfficials);
                    const updated_gameOfficials = this.selectedGame?.gameOfficials?.map((currentGo) => {
                      if (res?.includes(currentGo.id!)) { 
                        const updated_findGo: ClassGameOfficial = { ...currentGo, official: undefined, status: 'UNASSIGNED' };
                        return updated_findGo;
                      } else {
                        return currentGo;
                      }
                    }) || [];
                    const updated_game: ClassGame = { ...this.selectedGame, gameOfficials: updated_gameOfficials };
                    this.updateGame(updated_game, false);
                  }),
                );
            } else { 
              return of(null);
            }
          }),
        );
    } else {
      return of(null);
    }
  };

  deleteOfficialsWithoutRequest(): void {
    const exist_selectedArrGo_assigned_and_not_savedInServer = !!this.selectedArrGo_assigned_and_not_savedInServer?.length;
    if (!exist_selectedArrGo_assigned_and_not_savedInServer) return; 
    const updated_gameOfficials: Array<ClassGameOfficial> = this.selectedGame?.gameOfficials?.map((currentGo) => {
      const findGo = this.selectedArrGo_assigned_and_not_savedInServer.find(selectedGo => currentGo.id === selectedGo.id);
      if (findGo) {
        const updated_findGo: ClassGameOfficial = { ...findGo, official: undefined, status: 'UNASSIGNED' };
        return updated_findGo;
      } else {
        return currentGo;
      }
    }) || [];
    const updated_game: ClassGame = { ...this.selectedGame, gameOfficials: updated_gameOfficials };
    this.updateGame(updated_game, false);
  }

  goToAssign(gameItem: ClassGame): void {
    const goToAssign: IGoToAssign = {
      currentLink_games: this.gameS.currentLinkObj.currentLink?.upperCase || 'current',

    };
    if (gameItem.gameNumber) goToAssign.search = gameItem.gameNumber;
    if (gameItem.id) goToAssign.gameId = gameItem.id;
    this.router.navigate([urlAssign], { queryParams: goToAssign });
  }


  manageAllAndGoToAssign(typeBlockGamesForDashboard: TypeBlockGamesForDashboard): void {
    let settings: IGoToAssign = {};
    switch (typeBlockGamesForDashboard) {
      case 'pendingAssignments':
        settings = { gameStatuses: 'ACTIVE', status: 'UNACCEPTED', assignStatuses: 'UNACCEPTED,UNPUBLISHED' };
        break;
      case 'declinedAssignments':
        settings = { gameStatuses: 'ACTIVE', status: 'DECLINED', assignStatuses: 'DECLINED' };
        break;
      case 'unassignedRoles':
        settings = { gameStatuses: 'ACTIVE', status: 'UNASSIGNED', assignStatuses: 'UNASSIGNED' };
        break;
    }
    this.router.navigate([urlAssign], { queryParams: settings });
  }

}
